enum DictionariesAction {
  FETCH_ALL = 'dictionaries/fetchAll',
  FETCH_PROJECT_DICTIONARIES = 'projectDicitonaries/fetchAll',
  FETCH_ALLOCATIONS_DICTIONARIES = 'allocationsDictionaries/fetchAll',
  FETCH_INVOICE_DICTIONARIES = 'invoiceDictionaries/fetchAll'
}

export default DictionariesAction;
